import { render, staticRenderFns } from "./PronosticoSecciones.vue?vue&type=template&id=21f3f0e0&"
import script from "./PronosticoSecciones.vue?vue&type=script&lang=js&"
export * from "./PronosticoSecciones.vue?vue&type=script&lang=js&"
import style0 from "./PronosticoSecciones.vue?vue&type=style&index=0&id=21f3f0e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports